const MetaContent = {
  TITLE: '洗照片|相片沖印 無框畫,桌曆,相片書｜nuPhoto拍立洗',
  KEYWORDS: '洗照片,無框畫,相片書,桌曆,沖印,鑰匙圈,手機殼',
  DESCRIPTION: '洗照片第一品牌 AppStore 5顆星推薦 洗照片一張照片只要3元! 無框畫讓幸福回憶跳上牆壁 桌曆,相片書,筆記本 收藏送禮佈置 旅遊成長記錄 幸福滿滿! 相片沖印推薦第一名!',
  AUTHOR: 'nuPhoto拍立洗',
  OG_TITLE: '沖洗照片第一品牌 無框畫/相片書/鑰匙圈 洗照片每張3元!',
  OG_TYPE: 'website',
  OG_URL: 'https://nuphoto.com.tw',
  OG_IMAGE: 'https://nuphoto.com.tw/indexNCSS/MeshTile_1.02.jpg',
  OG_DESCRIPTION: 'nuPhoto拍立洗APP: 把手機照片作成相片書/無框畫/桌曆/鑰匙圈 當然還可以洗照片!',
  OG_SITENAME: '拍立洗APP'
} as const

export default MetaContent
